<template>
	<div>
		<j-base-select :value="computedValue" @input="onInput" :options="options" />

		<!-- When option Other is selected display text box -->
		<j-base-input-text
			v-if="computedValue === 'Other'"
			class="mt1"
			placeholder="Specify business activity"
			:value="value"
			@input="$emit('input', $event)"
		/>
	</div>
</template>

<script>
import JBaseSelect from "@/components/JBaseSelect"
import JBaseInputText from "@/components/JBaseInputText"

export default {
	components: { JBaseSelect, JBaseInputText },
	props: {
		value: {
			type: String
		}
	},

	data() {
		return {
			form: {
				others: ""
			},

			options: [
				{
					name: "Manufacturer",
					value: "Manufacturer"
				},
				{
					name: "Distributor",
					value: "Distributor"
				},
				{
					name: "Retailer",
					value: "Retailer"
				},
				{
					name: "Importer",
					value: "Importer"
				},
				{
					name: "Exporter",
					value: "Exporter"
				},
				{
					name: "Other",
					value: "Other"
				}
			]
		}
	},

	computed: {
		computedValue() {
			return this.options.find(option => option.value === this.value)
				? this.value
				: "Other"
		}
	},

	methods: {
		onInput(value) {
			// If value is "Other" emit empty string so that text input will be empty
			if (value === "Other") this.$emit("input", "")
			else this.$emit("input", value)
		}
	}
}
</script>
